import { getRequest, postRequest, patchRequest } from "../utils/axios";

export const apiTokensService = {
  listTokens: (onSuccess, onError) => getRequest("/api/v1/api-tokens/", onSuccess, onError),
  createToken: (data, onSuccess, onError) =>
    postRequest("/api/v1/api-tokens/", data, onSuccess, onError),
  revokeToken: (hash, onSuccess, onError) =>
    postRequest(`/api/v1/api-tokens/${hash}/revoke/`, {}, onSuccess, onError),
  playgroundSession: (hash, onSuccess, onError) =>
    postRequest(`/api/v1/api-tokens/${hash}/playground-session/`, {}, onSuccess, onError),
  listRequests: (params, onSuccess, onError) => {
    const query = new URLSearchParams(params || {}).toString();
    return getRequest(`/api/v1/api-requests/${query ? `?${query}` : ""}`, onSuccess, onError);
  },
  usage: (params, onSuccess, onError) => {
    const query = new URLSearchParams(params || {}).toString();
    return getRequest(`/api/v1/api-requests/usage/${query ? `?${query}` : ""}`, onSuccess, onError);
  },
  updateToken: (hash, data, onSuccess, onError) =>
    patchRequest(`/api/v1/api-tokens/${hash}/`, data, onSuccess, onError),
};
